import React from 'react';
export const TrustBar = () => {
  const developers = ['EMAAR', 'SOBHA', 'DAMAC', 'NAKHEEL', 'MERAAS'];
  return <section className="bg-[#1a2e1c] py-12 md:py-16 relative overflow-hidden" data-id="element-324">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-4xl bg-[#d8a34d] opacity-[0.05] blur-3xl pointer-events-none" data-id="element-325"></div>

      <div className="container mx-auto px-4 md:px-8 relative z-10" data-id="element-326">
        {/* Trust Logos */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 mb-12" data-id="element-327">
          {/* Dubai Land Department */}
          <div className="flex flex-col items-center gap-3" data-id="element-328">
            <div className="bg-white/95 rounded-lg px-5 py-3" data-id="element-329">
              <img src="https://cdn.magicpatterns.com/uploads/cu3MDDjCGv6evPcHWpiV4U/Dubai_Land_Department_compliant.png" alt="Dubai Land Department" className="h-12 md:h-12 object-contain" data-id="element-330" />
            </div>
            <span className="text-white/70 text-xs md:text-sm font-medium tracking-wide" data-id="element-331">
              Dubai Land Department Compliant
            </span>
          </div>

          {/* Divider */}
          <div className="hidden md:block w-px h-16 bg-white/15" data-id="element-332"></div>

          {/* RERA */}
          <div className="flex flex-col items-center gap-3" data-id="element-333">
            <div className="bg-white/95 rounded-lg px-5 py-3" data-id="element-334">
              <img src="https://cdn.magicpatterns.com/uploads/1xJZhj4hfNVptFz8oMkj5q/rera_1-removebg-preview.png" alt="RERA - The Real Estate Regulatory Agency" className="h-12 md:h-18 object-contain" data-id="element-335" />
            </div>
            <span className="text-white/70 text-xs md:text-sm font-medium tracking-wide" data-id="element-336">
              RERA Registered Advisors
            </span>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full max-w-3xl mx-auto h-px bg-gradient-to-r from-transparent via-[#d8a34d]/30 to-transparent mb-10" data-id="element-337"></div>

        {/* Developers Row */}
        <div className="flex flex-col items-center" data-id="element-338">
          <span className="text-white/50 text-xs tracking-[0.2em] uppercase mb-8" data-id="element-339">
            Partnered Developers
          </span>

          <div className="flex flex-wrap justify-center items-center gap-10 md:gap-16" data-id="element-340">
            <img src="https://cdn.magicpatterns.com/uploads/qA5VzJ1ypcC8H2566yfiEa/svgviewer-output_(3).svg" alt="Emaar" className="h-8 md:h-10 object-contain opacity-80" data-id="element-341" />
            <img src="https://cdn.magicpatterns.com/uploads/rc7ZimH8Cw8GfHCLG1LrRj/Sobha-white-Logoneww.png" alt="Sobha" className="h-8 md:h-12 object-contain opacity-80" data-id="element-342" />
            <img src="https://cdn.magicpatterns.com/uploads/5jAG46wYymUPPjX925Z3sH/damac-logo-white.png" alt="Damac" className="h-7 md:h-10 object-contain opacity-80" data-id="element-343" />
            <img src="https://cdn.magicpatterns.com/uploads/fXEGCjPqXSfDHsFhaxrN73/nakheel-white-logo.png.webp" alt="Nakheel" className="h-10 md:h-14 object-contain opacity-80" data-id="element-344" />
            <img src="https://cdn.magicpatterns.com/uploads/fMAaDkRNRDHfa2eVef3FFi/Meraas-Eng-Whiteout-logo.png" alt="Meraas" className="h-8 md:h-12 object-contain opacity-80" data-id="element-345" />
            <span className="text-white/50 text-sm md:text-base font-medium italic" data-id="element-346">
              & More
            </span>
          </div>
        </div>
      </div>
    </section>;
};